import path from '@/api/index'
import { axios } from '@/utils/request'
import parsePageParams from "../../utils/page";


// 分页
export function pageList(data) {
    return axios({
        url: path.client + '/noticeInfo',
        method: 'POST',
        data: data,
        params: parsePageParams(data)
    })
}

export function getNoticeById (id) {
    return axios({
        url: path.client + '/noticeInfo/id/'+id,
        method: 'GET'
    })
}


